import { eventsTable } from '@/controllers/events-table'
import { pineapple } from '@/controllers/events'

const [route, action] = ['pineapple', 'update-general-info']

export const updatePineappleGeneralInfo = function (data, callback) {
  window[Symbol.for('vue.prototype')].$sendMessageToWorker({ route, action, data })

  eventsTable[pineapple[action]] = callback
}
